/*eslint-disable*/
import React from "react";
import {
  Flex,
  Link,
  List,
  ListItem,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  let textColor = useColorModeValue("gray.400", "grey.500");
  let linkColor = useColorModeValue({ base: "gray.400", lg: "grey.500" }, "grey.500");
  return (
    <Flex
      zIndex='3'
      flexDirection={{
        base: "column",
        lg: "row",
      }}
      alignItems={{
        base: "center",
        xl: "start",
      }}
      justifyContent='space-between'
      px={{ base: "30px", md: "0px" }}
      pb='30px'>
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "start",
        }}
        mb={{ base: "20px", lg: "0px" }}>
        {" "}
        &copy; {1900 + new Date().getYear()}
        <Text as='span' fontWeight='500' ms='4px'>
          {t('BlockMap, All Rights Reserved.')}
          <Link
            mx='3px'
            color={textColor}
            href='https://www.ethion.cloud'
            target='_blank'
            fontWeight='700'>
            {t('Powered by Ethion!')}
          </Link>
        </Text>
      </Text>
      <List display='flex'>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link
            fontWeight='500'
            color={linkColor}
            href='mailto:hello@trovilo.co'>
            {t('Support')}
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link
            fontWeight='500'
            color={linkColor}
            href='https://blockmap.dev/terms-of-use'>
            {t('Terms of Use')}
          </Link>
        </ListItem>
        <ListItem
          me={{
            base: "20px",
            md: "44px",
          }}>
          <Link
            fontWeight='500'
            color={linkColor}
            href='https://blockmap.dev/blog'>
            {t('Blog')}
          </Link>
        </ListItem>
      </List>
    </Flex>
  );
}
